import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hiddenInput', 'digitInputs']

  connect() {
    if (this.digitInputsTargets.length > 0) {
      setTimeout(() => this.digitInputsTargets[0].focus(), 0)
    }
  }

  handleInput(event) {
    const input = event.target
    const index = this.digitInputsTargets.indexOf(input)
    const value = input.value.replace(/\D/g, '')

    if (value.length > 1) {
      this.fillFromPaste(value)
      return
    }

    input.value = value

    if (value && index < this.digitInputsTargets.length - 1) {
      this.digitInputsTargets[index + 1].focus()
    }

    this.updateHiddenInput()
  }

  fillFromPaste(pastedText) {
    const digits = pastedText.slice(0, this.digitInputsTargets.length).split('')

    this.digitInputsTargets.forEach((input, i) => {
      input.value = digits[i] || ''
    })

    const focusIndex = Math.min(digits.length, this.digitInputsTargets.length - 1)
    this.digitInputsTargets[focusIndex].focus()

    this.updateHiddenInput()
  }

  handleKeyInput(event) {
    const input = event.target
    const index = this.digitInputsTargets.indexOf(input)

    if (event.key === 'Backspace') {
      if (input.value) {
        input.value = ''
        this.updateHiddenInput()
      } else if (index > 0) {
        const prev = this.digitInputsTargets[index - 1]
        prev.focus()
        prev.value = ''
        this.updateHiddenInput()
      }
    }

    if (event.key === 'ArrowLeft' && index > 0) {
      this.digitInputsTargets[index - 1].focus()
    }

    if (event.key === 'ArrowRight' && index < this.digitInputsTargets.length - 1) {
      this.digitInputsTargets[index + 1].focus()
    }
  }

  updateHiddenInput() {
    const value = this.digitInputsTargets.map(input => input.value).join('')
    this.hiddenInputTarget.value = value
  }
}
